import  FreeSpinCell  from "./FreeSpinCell"
import Utils from "../../utils/Utils";
import ResourcesDispatcher from "../../config/ResourcesDispatcher";

export default class FreeSpinReel {
    protected scene: any;

    public gameDataManager: any;
    public gameLogicVariableManager: any;

    protected index: number = 0;
    protected container: Phaser.GameObjects.Container;

    protected spinProgress!: Phaser.Tweens.Tween;
    protected bounceTween1: Phaser.Tweens.Tween | undefined;
    protected bounceTween2: Phaser.Tweens.Tween | undefined;
    protected spinProgressValue: { value: number; } = { value: 0 };
    public readonly spinAnimationDuration: number = 50;

    protected virtualReelPosition: number = 0;
    protected realMemoIndex: number = 0;
    public canStop: boolean | undefined;
    public mustStop: boolean | undefined;
    public stopped: boolean | undefined;
    public forced: boolean | undefined;
    public mustEnableStop: boolean | undefined;

    public numOfCellsPerReel: any;
    public numOfExtraCellsPerReel: any;

    public freeSpinCells: FreeSpinCell[] = [];
    public cellSize: any;
    public cellPosition: any;
    public lastCellIndex: any;

    public stopEvent: Phaser.Time.TimerEvent | undefined;
    public reelMask!: Phaser.GameObjects.Graphics;
    protected spinMainButtonTween: Phaser.Tweens.Tween = null as any;

    constructor(scene: any, x: number, y: number, index: number, orientation: any) {
        this.scene = scene;
        this.gameLogicVariableManager = (window as any).GameLogicVariableManager;
        this.gameDataManager = (window as any).GameDataManager;

        this.index = index;

        this.numOfCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL;
        this.numOfExtraCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_CELLS_PER_REEL;
        this.lastCellIndex = ResourcesDispatcher.GAME_CONSTANTS.LAST_CELL_INDEX;
        this.cellSize = ResourcesDispatcher.GAME_CONSTANTS.CELL_SIZE;

        this.container = this.scene.add.container(x, y);
        this.createReelMask(orientation);

        // this.freeSpinCells = freeSpinCellCreation.cells;
        // this.cellPosition = freeSpinCellCreation.cellPositions;
    }

    public setFreeSpinCellCreation(freeSpinCellCreation: { cells: FreeSpinCell[]; cellPositions: any[] }) {
        this.freeSpinCells = freeSpinCellCreation.cells;
        this.cellPosition = freeSpinCellCreation.cellPositions;
    }

    public createReelMask(orientation: any): void {}

    public setIndex(index: number) {
        this.index = index;
    }

    public getIndex(): number {
        return this.index;
    }

    public getContainer(): Phaser.GameObjects.Container {
        return this.container;
    }

    public resetFlagsAndCounters() {
        this.turnOn();
        this.virtualReelPosition = Utils.getRandomInt(0, this.scene.freeSpinGameArea.virtualGrid[this.index].length - 1);
        this.spinProgressValue = { value: 0 };
        this.stopped = false;
        this.forced = false;
        this.canStop = false;
        this.mustStop = false;
        this.mustEnableStop = false;
        this.realMemoIndex = 0;

        this.removeStopEvent();
    }

    public turnOn() {
        this.freeSpinCells.forEach(
            (cell) => {
                cell.turnOn();
            }
        );
    }

    public turnOff() {
        this.freeSpinCells.forEach(
            (cell) => {
                cell.turnOff();
            }
        );
    }

    public resetCellsPositions() {
        this.freeSpinCells.forEach((cell, index) => {
            cell.getContainer().y = (this.cellSize.height * index) - (this.cellSize.height / 2);
        });
    }

    public reIndexCells() {
        let freeSpinCells: FreeSpinCell[] = [];

        for (let i = 1; i < this.numOfCellsPerReel + this.numOfExtraCellsPerReel; i++) {

            freeSpinCells[i - 1] = this.freeSpinCells[i];
            this.freeSpinCells[i].setIndex(i - 1);
        }

        this.freeSpinCells[0].setIndex(this.lastCellIndex);
        freeSpinCells[this.lastCellIndex] = this.freeSpinCells[0];

        this.freeSpinCells = [];
        this.freeSpinCells = freeSpinCells;
    }

    public configureFreeSpinTween() {}

    public spin(mainButtonBackground?: any) {
        this.spinProgress.play();

        if(mainButtonBackground){
            if ((window as any).isButtonSpinning === false) {
                (window as any).isButtonSpinning = true;            
                this.spinMainButtonTween = Utils.spinMainButtonRotation(mainButtonBackground, this.scene);
            }
        }
    }

    public bounce() {}

    public removeStopEvent() {
        if (this.stopEvent) {
            this.stopEvent.remove(false);
        }

        this.stopEvent = undefined;
    }
}
